import { NotificationService } from '@cradua/core';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { map, catchError, concatMap, exhaustMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as ProjectClusterActions from './project-cluster.actions';
import { ProjectClusterService } from '../../services/project-cluster.service';
import { Router } from '@angular/router';

@Injectable()
export class ProjectClusterEffects {
  loadProjectCluster$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectClusterActions.loadProjectCluster),
      exhaustMap((_) =>
        this.projectClusterService.getProjectCluster().pipe(
          map((data) =>
            ProjectClusterActions.loadProjectClusterSuccess({
              projectCluster: data,
            })
          ),
          catchError((error) => {
            if (error.statusText === 'Unknown Error') {
              this.notification.error(
                'Unable to get response from server, please try again'
              );
            }

            return of(
              ProjectClusterActions.loadProjectClusterFailure({
                error,
              })
            );
          })
        )
      )
    )
  );

  addProjectCluster$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectClusterActions.addProjectCluster),
      concatMap(({ newProjectCluster }) =>
        this.projectClusterService.createProjectCluster(newProjectCluster).pipe(
          map((data) => {
            this.notification.success('Saved Successfully');
            return ProjectClusterActions.addProjectClusterSuccess({
              newProjectCluster: data,
            });
          }),
          catchError((error) => {
            console.log('error ', error);

            return of(
              ProjectClusterActions.addProjectClusterFailure({
                error: error.error.message,
              })
            );
          })
        )
      )
    )
  );

  // addSuccess$ = createEffect(
  // 	() =>
  // 		this.actions$.pipe(
  // 			ofType(ProjectClusterActions.addProjectClusterSuccess),
  // 			tap(() => {
  // 				return this.router.navigate([ '/project' ]);
  // 			})
  // 		),
  // 	{ dispatch: false }
  // );

  updateProjectCluster$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectClusterActions.updateProjectCluster),
      concatMap(({ updateProjectCluster }) =>
        this.projectClusterService
          .updateProjectCluster(updateProjectCluster)
          .pipe(
            map((data) => {
              // console.log('update effect data ', data);
              this.notification.success('Updated Successfully');
              return ProjectClusterActions.updateProjectClusterSuccess({
                updateProjectCluster: data,
              });
            }),
            catchError((error) => {
              return of(
                ProjectClusterActions.updateProjectClusterFailure({
                  error: error.message,
                })
              );
            })
          )
      )
    )
  );

  updateSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ProjectClusterActions.updateProjectClusterSuccess),
        tap(() => {
          console.log('navigate');
          return this.router.navigate(['/project']);
        })
      ),
    { dispatch: false }
  );

  removeProjectCluster$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectClusterActions.removeProjectCluster),
      map((action) => action.ids),
      concatMap((ids) =>
        this.projectClusterService.deleteProjectCluster(ids).pipe(
          map(() => {
            this.notification.success('Deleted Successfully');
            return ProjectClusterActions.removeProjectClusterSuccess({ ids });
          }),
          catchError((error) =>
            of(
              ProjectClusterActions.updateProjectClusterFailure({
                error: error.message,
              })
            )
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private projectClusterService: ProjectClusterService,
    private notification: NotificationService,
    private router: Router
  ) {}
}
